import React, { useRef, memo } from "react"
import styled from "styled-components"

import { Flex } from "components/box"
import { useOutsideClick } from "hooks/useOutsideClick"

const Container = styled(Flex)`
  align-items: center;
  cursor: pointer;
`

type NavigationDropdownProps = {
  isOpen: boolean
  children: React.ReactNode
  handleClose: () => void
  openedDropdownContent: React.ReactNode
}

const NavigationDropdown: React.FC<NavigationDropdownProps> = ({
  isOpen,
  children,
  handleClose,
  openedDropdownContent
}) => {
  const nodeRef = useRef<HTMLDivElement>(null)

  useOutsideClick(nodeRef, handleClose)

  return (
    <Container ref={nodeRef}>
      {children}
      {isOpen && openedDropdownContent}
    </Container>
  )
}

export default memo(NavigationDropdown)
